/** Rótulos de todas as formas de pagamento, inclusive as que saíram do formulário. */
export const paymentMethodLabels: Record<string, string> = {
  PIX: 'Pix',
  CREDIT_CARD: 'Cartão de crédito',
  CASH: 'Dinheiro',
  BANK_SLIP: 'Boleto',
};

export function paymentMethodLabel(value: string): string {
  return paymentMethodLabels[value?.toUpperCase()] ?? value;
}

/** O que o prestador pode escolher ao criar/editar um serviço. */
export const paymentMethodOptions = ['PIX', 'CREDIT_CARD', 'CASH'].map((value) => ({
  value,
  label: paymentMethodLabels[value],
}));
